import EventsCalendar from "components/investorrelations/EventsCalendar";
import EventsCalendarList from "components/investorrelations/EventsCalendarList";
import type { EventsCalendarState } from "components/investorrelations/EventsCalendarLocalState";
import RightSideFilters, { RightSideFiltersEnum } from "components/investorrelations/RightSideFilters";
import { IIssuerType } from "types/graphqlTypes";

interface BrazilianCalendarContentProps extends EventsCalendarState {
  tickerSymbol: string;
  isRenderPageDefault: boolean;
}

export default function BrazilianCalendarContent({
  tickerSymbol,
  isRenderPageDefault,
  ...filterState
}: BrazilianCalendarContentProps) {
  return (
    <EventsCalendar
      {...filterState}
      issuerType={IIssuerType.BrazilianCompany}
      searchQuery={tickerSymbol}
      limit={isRenderPageDefault ? 5 : 20}
    >
      {({ data, error, loading, isLoadingMore, loadMoreEvents }) => {
        return (
          <>
            <div className="col-span-12 row-start-2 space-y-4 lg:col-span-8 lg:row-start-1">
              <div className="flex flex-col">
                <EventsCalendarList
                  {...filterState}
                  eventsCalendar={data}
                  searchQuery={tickerSymbol}
                  loading={loading}
                  isLoadingMore={isLoadingMore}
                  loadMoreEvents={loadMoreEvents}
                  error={error}
                />
              </div>
            </div>

            <div className="col-span-12 space-y-4 lg:col-span-4">
              <RightSideFilters
                {...filterState}
                eventsCalendar={data}
                issuerType={IIssuerType.BrazilianCompany}
                className="grid-cols-2 sm:relative sm:top-0"
                enableFilters={[
                  RightSideFiltersEnum.EventType,
                  RightSideFiltersEnum.FilterRange,
                  RightSideFiltersEnum.MonthViewCalendar,
                ]}
              />
            </div>
          </>
        );
      }}
    </EventsCalendar>
  );
}
